import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import styles from "./Button.css";
import { Link } from "react-router-dom";

export default function Button({
  children,
  className,
  destructive = false,

  // Destructure the testid prop so it's not copied into the <button>, and
  // Enzyme doesn't see it twice.
  // eslint-disable-next-line no-unused-vars
  "data-testid": _dataTestId,
  fullWidth = false,
  isDisabled = false,
  onClick,
  type,
  htmlType,
  ...rest
}) {
  const buttonProps = {
    className: classNames(
      styles.button,
      styles[type || "primary"],
      { [styles.disabled]: isDisabled },
      { [styles.destructive]: destructive },
      { [styles.fullWidth]: fullWidth },
      className // additional classes passed through in props
    ),
    onClick: isDisabled ? () => {} : onClick,
    disabled: isDisabled,
    ...rest, // Pass through arbitrary extra properties e.g., aria/role attributes,
  };
  return !isDisabled && rest.to ? (
    <Link {...buttonProps}>{children}</Link>
  ) : (
    <button type={htmlType} {...buttonProps}>
      {children}
    </button>
  );
}

Button.propTypes = {
  /**
   * Primary: Blue background and outline, white text
   * Secondary: White background, blue outline, blue text
   * Tertiary: No background, no outline, blue text
   * Submit: Primary button with additional width/margin styling
   * Cancel: Secondary button with additional width/margin styling
   */
  type: PropTypes.oneOf([
    "primary",
    "secondary",
    "tertiary",
    "cancel",
    "submit",
  ]),
  htmlType: PropTypes.string,
  onClick: PropTypes.func,
  isDisabled: PropTypes.bool,
  destructive: PropTypes.bool,

  // Pass additional classNames to be added
  className: PropTypes.string,
  validateDestructive: function(props) {
    if (props.destructive && props.type !== "tertiary") {
      return new Error("Only tertiary buttons can be destructive.");
    }
  },
};
